import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { motion } from 'framer-motion';
import whoweare from '../../../assets/Images/whoweare.png';

const WhoWeAreSection = () => {
  return (
    <Box 
      sx={{ 
        py: { xs: 6, md: 10 },
        backgroundColor: '#fff',
        overflow: 'hidden', 
        // height: { md: '500px', xs: 'auto' }, // Remove fixed height
      }}
    >
      <Container maxWidth="lg">
        <Grid 
          container 
          spacing={{ xs: 4, md: 8 }} 
          alignItems="center"
          // sx={{ height: '100%' }} // Remove grid fixed height
        >
          {/* Left Content */}
          <Grid 
            item 
            xs={12} 
            md={6}
            sx={{
              pr: { md: 4 }, 
              // height: '100%', // Remove item fixed height
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2.5rem', md: '2.5rem' },
                  fontWeight: 900,
                  color: '#112D4E',
                  mb: 4,
                  textTransform: 'uppercase',
                  letterSpacing: '0.02em',
                }}
              >
                Who We Are
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  color: '#666',
                  mb: 3,
                  lineHeight: 1.8,
                  maxWidth: '600px', 
                  textAlign: 'justify'
                }}
              >
                Virves Software Solutions is a full-cycle custom software development company providing 
                enterprise software development services, software consulting, dedicated software 
                development teams and mobile app development solutions for businesses.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  color: '#666',
                  lineHeight: 1.8,
                  maxWidth: '600px', 
                  textAlign: 'justify'
                }}
              >
                At Virves, we ensure that we deliver the highest standards of excellence. In order to 
                provide that, we make sure to approach the process with a smart strategy that's put 
                together after understanding all the key nuances involved.
              </Typography>
              <Box
                sx={{
                  width: '80px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #3F72AF 0%, #112D4E 100%)',
                  mt: 4,
                  borderRadius: '2px',
                }}
              />
            </motion.div>
          </Grid>

          {/* Right Image */}
          <Grid 
            item 
            xs={12} 
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // height: '100%', // Remove item fixed height
            }}
          >
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              style={{ width: '100%' }}
            >
              <Box
                component="img"
                src={whoweare}
                alt="Team working on software development"
                sx={{
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto',
                  maxHeight: '500px',
                  objectFit: 'cover',
                  display: 'block',
                  margin: '0 auto',
                }}
                onError={(e) => {
                  e.target.src = 'https://source.unsplash.com/random/800x600?software,development';
                }}
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default WhoWeAreSection; 